import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "./rendom_code";
import { deletecompaniesFileByUid } from "./deletecompaniesFileByUid";
import imageCompression from "browser-image-compression";
import { deleteFileByUid } from "./deleteFileByUid";
export const Uploader_companies_files = async (data) => {
  const {servicetablename, file, tablename, fileuid, filename, old_file_uid } = data || {};

  // 1. Validate inputs
  if (!fileuid?.trim()) return { success: false, error: "Missing fileUID" };
  if (!file) return { success: false, error: "Missing file" };
  if (!tablename?.trim()) return { success: false, error: "Missing tablename" };
  if (!filename?.trim()) return { success: false, error: "Missing filename" };
if (
  !(
    file.type.startsWith("image/") ||
    file.type === "video/mp4"
  )
) {
  return { success: false, error: "Only image and .mp4 video files are allowed!" };
}
  // ✅ Compress if file > 1MB
  let uploadFile = file;
  if (file.size > 1 * 1024 * 1024) {
    try {
      const options = {
        maxSizeMB: 1, // target under 1 MB
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      uploadFile = await imageCompression(file, options);

      console.log(
        `Original size: ${(file.size / 1024 / 1024).toFixed(2)}MB → Compressed: ${(uploadFile.size / 1024 / 1024).toFixed(2)}MB`
      );

      // ✅ Check AFTER compression
      if (uploadFile.size > 1 * 1024 * 1024) {
        return { success: false, error: "File is still over 1MB after compression!" };
      }
    } catch (err) {
      return { success: false, error: "Image compression failed: " + err.message };
    }
  }

  // ✅ Session validation
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const companyuid = Cookies.get("select_company_uid");
  if (!sessiontoken || !guid) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!companyuid || companyuid === "undefined") {
    return { success: false, error: "Please select company." };
  }

  try {
    const storage = getStorage();
    const uid = Randomcode(22);
    const filename_url = `${uid}.${uploadFile.name.split(".").pop()}`;
    const storageRef = ref(storage, `uploadsfiles/${companyuid+"/"+tablename+"/"+filename_url}`);

    return new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(storageRef, uploadFile);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload progress: ${Math.round(percent)}%`);
        },
        (err) => {
          console.error("Upload failed:", err);
          reject({ success: false, error: err.message || err.code || err });
        },
        async () => {
          try {
            const url = await getDownloadURL(uploadTask.snapshot.ref);

                  const fileDocRef = doc(
              db,
              servicetablename,
              companyuid,
              "files",
              uid
            );

            await setDoc(fileDocRef, {
              uid,
              companyuid,
              tablename,
              fileuid,
              filename,
              url,
              size: uploadFile.size,
              type: uploadFile.type,
              guid,
              sessiontoken,
              date_time: new Date(),
            }, { merge: true });
           // await setDoc(parentDocRef, savequery, { merge: true });

            const updatefile = doc(db, tablename, fileuid);
            const updatefilequery = {
              [filename + "_url"]: url,
              [filename + "_uid"]: uid,
            };
            await setDoc(updatefile, updatefilequery, { merge: true });

            if (old_file_uid !=null && old_file_uid?.trim() && old_file_uid !== uid) {
             // deletecompaniesFileByUid(old_file_uid);
                deleteFileByUid(old_file_uid,servicetablename);
            }

            resolve({ success: true, fileurl: url });
          } catch (firestoreErr) {
            reject({ success: false, error: firestoreErr.message });
          }
        }
      );
    });
  } catch (err) {
    console.error("Upload failed:", err);
    return { success: false, error: err.message || err.code || err };
  }
};
